import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const strong: SugarElementInfo = { name: "strong", availableChildren: { type: AvailableChildrenType.Any } };
